<template>
  <div id="app">
    <bnj-header v-show="!isMobile"></bnj-header> 
    <bnj-header-mobile v-show="isMobile"></bnj-header-mobile>
    <router-view />
    <bnj-footer v-show="!isMobile"></bnj-footer>
    <bnj-footer-mobile v-show="isMobile"></bnj-footer-mobile>
  </div>
</template>

<script>
import BnjHeader from '_c/bnj-header'
import BnjFooter from '_c/bnj-footer'
import BnjHeaderMobile from '_c/bnj-header-mobile'
import BnjFooterMobile from '_c/bnj-footer-mobile'
export default {
  name: 'App',
  data () {
    return {
      isMobile: false
    }
  },
  components: {
    BnjHeader,
    BnjFooter,
    BnjHeaderMobile,
    BnjFooterMobile
  },
  mounted () {
    this.isMobile = this.checkMobile()
  },
  methods: {
    checkMobile () {
	    let flag = navigator.userAgent.match(/(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
	    return flag
    }
  }
}

</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue